export class UserModel {
    id: string;
    username: string;
    displayname: string;
    password: string;
    refresh_token: string;
    isadmin: boolean;
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/models/user.model.ts